import { Component, NgZone, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";

import { TravelsHandlerService } from "../../../../api-handlers/travels-handler.service";
import { AdminChangeTravelsComponent } from "../../../../dialogs/admin-change-travels/admin-change-travels.component";
import { RefreshCheckService } from "../../../../commons/refresh-superadmin-data.service";

@Component({
  selector: "app-manage-travels",
  templateUrl: "./manage-travels.component.html",
  styleUrls: ["./manage-travels.component.css"],
})
export class ManageTravelsComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(AdminChangeTravelsComponent, { static: false })
  adminChangeTravelsDialog: AdminChangeTravelsComponent;

  parkId: number;
  parkName: string;
  travels: any[] = [];

  travelsTableDataSource: MatTableDataSource<Object>;
  travelsDisplayedColumns: string[] = [
    "trv_id",
    "trv_started_at",
    "trv_ended_at",
    "vhc_plate",
    "trv_start_kilometers",
    "trv_end_kilometers",
    "usr_surname",
    "statusDesc",
    "actions",
  ];

  constructor(
    private activatedRoute: ActivatedRoute,
    private ngZone: NgZone,
    public travelsHandlerService: TravelsHandlerService,
    private refreshService: RefreshCheckService
  ) {}

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.parkId = Number(params.get("parkId"));
      this.parkName = decodeURI(params.get("parkName"));
    });

    this.reloadTravels();

    this.refreshService.refreshTravelData$.subscribe((shouldRefresh) => {
      if (shouldRefresh) {
        this.reloadTravels();
      }
    });
  }

  reloadTravels() {
    this.travelsHandlerService
      .getTravelsByParkId(this.parkId.toString())
      .then((res: any) => {
        this.ngZone.run(() => {
          this.travels = res["travel"];

          this.travels.forEach((trv) => {
            trv.statusDesc = this.getStatus(trv);
          });

          this.travelsTableDataSource = new MatTableDataSource(this.travels);
          this.travelsTableDataSource.paginator = this.paginator;
          this.travelsTableDataSource.sort = this.sort;

          this.travelsTableDataSource.filterPredicate = (
            data: any,
            filter: string
          ): boolean =>
            data.vhc_plate
              ? data.vhc_plate.toLowerCase().includes(filter)
              : false;
        });
      });
  }

  onTravelRowActionHandler(rowData) {
    this.adminChangeTravelsDialog.showDialog(rowData);
  }

  applyTravelSearchFilter(filterVal) {
    this.travelsTableDataSource.filter = filterVal.trim().toLowerCase();
  }

  reloadAfterUpdateEmit() {
    this.reloadTravels();
  }

  getStatus(travel): string {
    return this.travelsHandlerService.getTravelStatusDescription(
      this.travelsHandlerService.getTravelStatus(travel)
    );
  }
}
